export const toggle = ({
  show,
  hide,
  showDuration,
  hideDuration
}: {
  show: () => void;
  hide: () => void;
  showDuration: number;
  hideDuration: number;
}) => {
  const seq = () =>
    setTimeout(() => {
      show();
      setTimeout(() => {
        hide();
        seq();
      }, showDuration);
    }, hideDuration);
  seq();
};
